"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import { Debounce } from "vue-debounce-decorator";
let AutoStartConfig = class extends Vue {
  constructor() {
    super(...arguments);
    this.autoStart = false;
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.get_settings();
    });
  }
  changeAutoStart() {
    return __async(this, null, function* () {
      yield API.put(`api://base.local/system/auto-launch`, {
        "enable": this.autoStart
      });
    });
  }
  get_settings() {
    return __async(this, null, function* () {
      let response = yield API.get(`api://base.local/system/auto-launch`);
      this.autoStart = response.data.is_enabled;
    });
  }
};
__decorateClass([
  Debounce(400)
], AutoStartConfig.prototype, "changeAutoStart", 1);
AutoStartConfig = __decorateClass([
  Component
], AutoStartConfig);
export {
  AutoStartConfig as default
};
